import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, isInvalid, Field, formValueSelector } from 'redux-form'
import { FORM_LISTADO_MUESTRAS_ENVIADAS } from '../../../../../config/forms'
import * as actions from '../actions/MenuDeMuestrasTablaActions'
import { renderTextField } from '../../../../Forms/fieldRenderers'
import { getNumericValidator } from '../../../../Forms/fieldValidators'
import { Row, Col, Button } from 'react-bootstrap'
import { Collapse, IconButton } from '@material-ui/core'
import DatePicker from '../../../../LaridaeApp/datepicker/container/DatePicker'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import { COLORES } from '../../../../../config/colores'

const numeric12 = getNumericValidator(11, 12)
const numeric15 = getNumericValidator(15)

class FormListadoConsulta extends Component {
  constructor (props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
    this.handleChangeMuestra = this.handleChangeMuestra.bind(this)
    this.handleChangeFechas = this.handleChangeFechas.bind(this)
    this.actualizarFechas = this.actualizarFechas.bind(this)
    this.state = {
      showcp: true,
      showmuestra: false,
      showfecha: false
    }
  }

  handleChange () {
    this.setState({ showcp: !this.state.showcp })
  }

  handleChangeMuestra () {
    this.setState({ showmuestra: !this.state.showmuestra })
  }

  handleChangeFechas () {
    this.setState({ showfecha: !this.state.showfecha })
  }

  actualizarFechas (fechaD, fechaH) {
    const { change: formChange } = this.props
    formChange('fechaD', fechaD)
    formChange('fechaH', fechaH)
  }

  render () {
    const {
      handleSubmit
    } = this.props
    const {
      showcp,
      showmuestra,
      showfecha
    } = this.state

    return (
      <div>
        <div style={{ margin: 'auto', maxWidth: '90%' }}>
          <Row style={{ justifyContent: 'center' }}>
            <Col md={10}>
              <h5 >Búsqueda por Carta de Porte</h5>
              <IconButton onClick={this.handleChange} style={{ float: 'left', outline: 'none', justifyContent: 'flex-start' }} className='iconbutton-muitables'>
                {showcp ? <KeyboardArrowUpIcon style={{ color: COLORES.grey.mediumDark }} />
                  : <KeyboardArrowDownIcon style={{ color: COLORES.grey.mediumDark }} /> }
              </IconButton>
              <Collapse in={showcp}>
                <Field
                  className='cpa'
                  name='numero'
                  type='text'
                  label='Nº de CPE'
                  component={renderTextField}
                  autoFocus
                  validate={[numeric12]}
                  placeholder='10201000000'
                />
              </Collapse>
              {!showcp && <div style={{ borderBottom: '1px solid', borderColor: COLORES.grey.light, width: '90%', marginLeft: '2%' }} />}
            </Col>
          </Row>
          <Row style={{ justifyContent: 'center' }}>
            <Col md={10}>
              <h5>Búsqueda por Número de Muestra</h5>
              <IconButton onClick={this.handleChangeMuestra} style={{ float: 'left', outline: 'none', justifyContent: 'flex-start' }} className='iconbutton-muitables'>
                {showmuestra ? <KeyboardArrowUpIcon style={{ color: COLORES.grey.mediumDark }} />
                  : <KeyboardArrowDownIcon style={{ color: COLORES.grey.mediumDark }} /> }
              </IconButton>
              <Collapse in={showmuestra}>
                <Field
                  className='cpa'
                  name='muestra'
                  type='text'
                  label='Nº de Muestra'
                  component={renderTextField}
                  validate={[numeric15]}
                  placeholder='902000241997436'
                />
              </Collapse>
              {!showmuestra && <div style={{ borderBottom: '1px solid', borderColor: COLORES.grey.light, width: '90%', marginLeft: '2%' }} />}
            </Col>
          </Row>
          <Row style={{ justifyContent: 'center' }}>
            <Col md={2} />
            <Col md={8}>
              <h5>Búsqueda por Fechas</h5>
              <IconButton onClick={this.handleChangeFechas} style={{ float: 'left', outline: 'none', justifyContent: 'flex-start' }} className='iconbutton-muitables'>
                {showfecha ? <KeyboardArrowUpIcon style={{ color: COLORES.grey.mediumDark }} />
                  : <KeyboardArrowDownIcon style={{ color: COLORES.grey.mediumDark }} /> }
              </IconButton>
              <Collapse in={showfecha}>
                <DatePicker
                  style={{ width: '95%' }}
                  disabledFuture
                  selectRange
                  locale='es'
                  // fechaHasta={fechaH}
                  onDateChange={this.actualizarFechas}
                  titulo='Inicio - Límite de consulta'
                // value='fechas'
                />
              </Collapse>
              {!showfecha && <div style={{ borderBottom: '1px solid', borderColor: COLORES.grey.light, width: '90%', marginLeft: '2%' }} />}
            </Col>
            <Col md={2} />
          </Row>
          <br />
          <Row>
            <Col md={12}>
              <Button
                size='lg'
                onClick={handleSubmit}
              >Consultar</Button>
            </Col>
          </Row>
        </div>
      </div>
    )
  }
}

const selector = formValueSelector(FORM_LISTADO_MUESTRAS_ENVIADAS)

const mapStateToProps = (state) => ({
  invalid: isInvalid(FORM_LISTADO_MUESTRAS_ENVIADAS)(state),
  fechaD: selector(state, 'fechaD'),
  fechaH: selector(state, 'fechaH')
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_LISTADO_MUESTRAS_ENVIADAS,
  destroyOnUnmount: false,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(FormListadoConsulta))
